export const SPORTSBOOK_QUERY_KEY = 'sportsbook';
